import React, { ReactElement } from 'react';

export default function Import(): ReactElement {
  return (
    <div className="header-bar">
      <h1>Import Data</h1>
    </div>
  )
}
